{
  "LOGIN": {
    "TITLE": "Log In",
    "SUBTITLE": "Access your account to continue",
    "EMAIL": "Email",
    "EMAIL_PLACEHOLDER": "you@email.com",
    "EMAIL_REQUIRED": "Email is required.",
    "EMAIL_INVALID": "Please enter a valid email.",
    "PASSWORD": "Password",
    "PASSWORD_PLACEHOLDER": "••••••••",
    "PASSWORD_REQUIRED": "Password is required.",
    "PASSWORD_MIN": "Password must be at least 6 characters.",
    "BUTTON_LOADING": "Loading...",
    "BUTTON": "Log in",
    "OR": "or",
    "NO_ACCOUNT": "Don't have an account?",
    "REGISTER_HERE": "Register here",
    "FORGOT_PASSWORD": "Forgot your password?",
    "TERMS_1": "By logging in, you agree to our",
    "TERMS_2": "Terms of Service",
    "TERMS_3": "and",
    "TERMS_4": "Privacy Policy",
    "ERROR_GOOGLE": "Could not sign in with Google. Please try again.",
    "ERROR_PROFILE": "Could not load the user profile.",
    "ERROR_INVALID_CREDENTIALS": "Incorrect credentials. Please try again."
  },
  "REGISTER": {
    "TITLE": "Create Account",
    "SUBTITLE": "Join our community for free",
    "NAME": "Name",
    "NAME_PLACEHOLDER": "Your full name",
    "NAME_REQUIRED": "Name is required.",
    "NAME_MIN": "Name must be at least 4 characters.",
    "USERNAME": "Username",
    "USERNAME_PLACEHOLDER": "username",
    "USERNAME_REQUIRED": "Username is required.",
    "USERNAME_PATTERN": "Only letters, numbers, and underscores are allowed.",
    "USERNAME_AVAILABLE": "✓ Username available",
    "CONFIRM_PASSWORD": "Confirm Password",
    "CONFIRM_REQUIRED": "Password confirmation is required.",
    "PASSWORD_MISMATCH": "Passwords do not match.",
    "TERMS_AGREE": "I agree to the",
    "TERMS_REQUIRED": "You must accept the terms and conditions to continue.",
    "BUTTON_LOADING": "Creating account...",
    "BUTTON": "Sign Up",
    "HAVE_ACCOUNT": "Already have an account?",
    "LOGIN_HERE": "Log in here",
    "PASSWORD_STRENGTH": {
      "WEAK": "Weak",
      "FAIR": "Fair",
      "GOOD": "Good",
      "STRONG": "Strong",
      "DEFAULT": "Security"
    }
  },
  "BANNER": {
    "SIDEBAR_ARIA": "Profile Menu",
    "MY_PROFILE": "My Profile",
    "MY_CREATIONS": "My Creations",
    "SETTINGS": "Settings",
    "LOGOUT": "Logout",
    "SEARCH_PLACEHOLDER": "Search projects",
    "BOLA_8": "Bola 8",
    "CREATE": "Create",
    "PRO": "PRO",
    "UPGRADE_PRO": "Upgrade to Pro",
    "LOGO_ALT": "MyPlace Logo",
    "PROFILE_ALT": "Profile",
    "PROFILE_IMG_ALT": "Profile picture",
    "LOGIN": "Login",
    "REGISTER": "Register",
    "CONFIRM_LOGOUT": "Are you sure you want to log out?"
  },
  "ACCOUNT": {
    "BANNER_ALT": "User banner",
    "PROFILE_ALT": "Profile picture",
    "THUMBNAIL_ALT": "Thumbnail",
    "FOLLOW": "Follow",
    "FOLLOWING": "Following",
    "REPORT_USER": "Report User",
    "ABOUT_ME": "About me",
    "NO_BIO": "No bio",
    "MORE_INFO": "More information",
    "FOLLOWERS": "{{ count }} Followers",
    "JOINED_ON": "Joined on {{ date }}",
    "JOINED_RECENTLY": "Joined recently",
    "CREATIONS": "{{ count }} Creations",
    "SECTION_CREATIONS": "Creations",
    "SCROLL_LEFT": "Previous",
    "SCROLL_RIGHT": "Next",
    "SORT_NEWEST": "Newest",
    "SORT_LIKED": "Most liked",
    "SORT_OLDEST": "Oldest",
    "NOTIF_LOGIN_TITLE": "Sign in",
    "NOTIF_VERIFY_TITLE": "Verify your email",
    "NOTIF_FOLLOW_LOGIN": "You must sign in to follow other users.",
    "NOTIF_FOLLOW_VERIFY": "You need to verify your email before following other users.",
    "NOTIF_REPORT_LOGIN": "You must sign in to report a user.",
    "NOTIF_REPORT_VERIFY": "You need to verify your email before reporting a user."
  },
  "ACCOUNT_SETTINGS": {
    "TITLE": "Account Settings",
    "TAB_PROFILE": "Profile",
    "TAB_SECURITY": "Security",
    "NAME_LABEL": "Name",
    "BIO_LABEL": "Bio",
    "THEME_LABEL": "Theme",
    "THEME_DARK": "Dark",
    "THEME_LIGHT": "Light",
    "THEME_AUTO": "Auto",
    "SAVING": "Saving...",
    "SAVE": "Save",
    "PROFILE_PICTURE_LABEL": "Profile Picture",
    "PROFILE_PICTURE_ALT": "Profile Picture",
    "BANNER_LABEL": "Banner",
    "BANNER_ALT": "Banner",
    "ADD_BIO": "Add a bio...",
    "ACCOUNT_SECTION": "Account",
    "USERNAME_LABEL": "Username",
    "CHANGE_USERNAME": "Change username",
    "EMAIL_LABEL": "Email",
    "EMAIL_HINT": "To change your email go to the",
    "DELETE_ACCOUNT_BTN": "Delete Account",
    "DELETE_ACCOUNT_HINT": "This action is irreversible and will delete all your content.",
    "SOCIAL_NETWORKS": "Social Networks:",
    "YOUTUBE": "YouTube",
    "YOUTUBE_PLACEHOLDER": "https://youtube.com/",
    "FACEBOOK": "Facebook",
    "FACEBOOK_PLACEHOLDER": "https://facebook.com/",
    "X_PLACEHOLDER": "https://x.com/",
    "DISCORD": "Discord",
    "DISCORD_PLACEHOLDER": "https://discord.com/",
    "CHANGE_EMAIL_TITLE": "Change email",
    "CHANGE_EMAIL_DESC": "To change your email we need you to confirm your",
    "NEW_EMAIL_LABEL": "New email",
    "CURRENT_PASSWORD_LABEL": "Current password",
    "UPDATING": "Updating...",
    "UPDATE_EMAIL": "Update Email",
    "CHANGE_PASSWORD_TITLE": "Change password",
    "CHANGE_PASSWORD_DESC": "Enter your current password and then write the new password.",
    "NEW_PASSWORD_LABEL": "New password",
    "CONFIRM_PASSWORD_LABEL": "Confirm new password",
    "UPDATE_PASSWORD": "Update Password",
    "DELETE_MODAL_PERMANENT": "This action is",
    "DELETE_MODAL_PERMANENT_HIGHLIGHT": "permanent",
    "DELETE_MODAL_UNDONE": "and cannot be undone.",
    "DELETE_MODAL_WARNING": "All your projects, items, comments, followers, emojis and associated data will be permanently deleted.",
    "DELETE_CONFIRM_PASSWORD": "Confirm your password",
    "DELETE_GOOGLE_OPTIONAL": "(optional for Google accounts)",
    "DELETE_PASSWORD_PLACEHOLDER": "Enter your password",
    "CANCEL": "Cancel",
    "DELETING": "Deleting...",
    "NOTIF_VERIFY_TITLE": "Verify your email",
    "NOTIF_VERIFY_ACTION": "You need to verify your email before performing this action.",
    "NAME_LENGTH_ERROR": "Name must be between 3 and 30 characters.",
    "BIO_LENGTH_ERROR": "Bio cannot exceed 200 characters.",
    "SAVE_PROFILE_ERROR": "Error updating profile.",
    "URL_FORMAT_ERROR": "The URL must start with http:// or https://",
    "URL_YOUTUBE_ERROR": "The URL must be a valid link to YouTube.",
    "URL_FACEBOOK_ERROR": "The URL must be a valid link to Facebook.",
    "URL_X_ERROR": "The URL must be a valid link to X (Twitter).",
    "URL_DISCORD_ERROR": "The URL must be a valid link to Discord.",
    "URL_INVALID_ERROR": "The URL does not have a valid format.",
    "SOCIAL_SAVE_SUCCESS": "Social networks updated successfully.",
    "SOCIAL_SAVE_ERROR": "The social networks could not be updated.",
    "EMAIL_EMPTY_ERROR": "The email cannot be empty.",
    "CURRENT_PASSWORD_ERROR": "You must enter your current password.",
    "EMAIL_UPDATE_SUCCESS": "Email updated. Please verify your new email address.",
    "NOTIF_VERIFY_NEW_EMAIL_TITLE": "Verify your new email",
    "NOTIF_VERIFY_NEW_EMAIL_MSG": "A verification link has been sent to your new email address.",
    "EMAIL_UPDATE_ERROR": "The email could not be updated.",
    "NEW_PASSWORD_REQUIRED_ERROR": "You must enter and confirm the new password.",
    "PASSWORD_MIN_ERROR": "The new password must have at least 6 characters.",
    "PASSWORD_MISMATCH_ERROR": "The passwords do not match.",
    "PASSWORD_UPDATE_SUCCESS": "Password updated successfully.",
    "PASSWORD_UPDATE_ERROR": "The password could not be updated.",
    "DELETE_PASSWORD_ERROR": "Please enter your password to confirm.",
    "DELETE_ACCOUNT_ERROR": "Could not delete the account. Please try again."
  },
  "COMMENTS": {
    "LOADING": "Loading comments...",
    "LOAD_MORE": "Load more comments",
    "WRITE_COMMENT": "Write a comment...",
    "COMMENT_BTN": "Comment",
    "SENDING": "Sending...",
    "PROFILE_ALT": "Profile picture",
    "EDITED": "edited",
    "COPY": "Copy",
    "EDIT": "Edit",
    "DELETE": "Delete",
    "REPORT": "Report",
    "HIDE_REPLIES": "Hide",
    "VIEW_REPLIES": "View",
    "REPLY": "Reply",
    "REPLY_BTN": "Reply",
    "CANCEL": "Cancel",
    "SAVING": "Saving...",
    "SAVE": "Save",
    "EDIT_PLACEHOLDER": "Edit your comment...",
    "WRITE_REPLY": "Write your reply...",
    "REPLYING_TO": "Replying to",
    "NOTIF_LOGIN_TITLE": "Sign in",
    "NOTIF_ACTION_LOGIN": "You must sign in to perform this action.",
    "NOTIF_VERIFY_TITLE": "Verify your email",
    "NOTIF_ACTION_VERIFY": "You need to verify your email before continuing.",
    "EDIT_ERROR": "Error updating comment.",
    "DELETE_CONFIRM": "Are you sure you want to delete this comment?",
    "DELETE_ERROR": "Error deleting comment.",
    "SUBMIT_ERROR": "Error submitting comment. Please try again.",
    "REPLY_ERROR": "Error sending reply."
  },
  "CONTACT": {
    "BACK_HOME": "Back to home",
    "TITLE": "Contact",
    "SUBTITLE": "We are here to help you",
    "EMAIL_TITLE": "Email",
    "EMAIL_DESC": "For general inquiries, support or reports, write to us at:",
    "SOCIAL_TITLE": "Social Networks",
    "SOCIAL_DESC": "Follow us and contact us on our networks to stay up to date:",
    "SOCIAL_TWITTER": "𝕏 / Twitter",
    "SECURITY_TITLE": "Security Reports",
    "SECURITY_DESC_1": "If you find a security vulnerability, please report it to",
    "SECURITY_DESC_2": "We are committed to responding as quickly as possible.",
    "DMCA_TITLE": "Content Report (DMCA)",
    "DMCA_DESC_1": "If you believe any content on MyPlace infringes your copyright, send an email to",
    "DMCA_DESC_2": "with the following information:",
    "DMCA_ITEM_1": "Identification of the infringing content (direct link).",
    "DMCA_ITEM_2": "Identification of the protected material.",
    "DMCA_ITEM_3": "Your contact information and good faith statement."
  },
  "COOKIE_CONSENT": {
    "DESCRIPTION": "We use cookies to maintain your session, remember your preferences, and show personalized ads. By clicking \"Accept All\", you consent to the use of all cookies. You can manage them in our",
    "PRIVACY_LINK": "Privacy Policy",
    "ACCEPT": "Accept All",
    "REJECT": "Reject"
  },
  "CREATE_PROJECT": {
    "TITLE": "Create a new Project",
    "PROJECT_TITLE_LABEL": "Project Title:",
    "PROJECT_TITLE_REQUIRED": "The title is required.",
    "DESCRIPTION_LABEL": "Description:",
    "PROJECT_TYPE_TITLE": "Project Type",
    "PROJECT_TYPE_WORLD_CUP": "World Cup",
    "PROJECT_TYPE_TIERLIST": "Tierlist",
    "PROJECT_TYPE_KMK": "KMK",
    "NEXT": "Next",
    "THUMBNAIL_TITLE": "Thumbnail & Confirm",
    "TITLE_DISPLAY": "Title:",
    "DESCRIPTION_DISPLAY": "Description:",
    "NOT_PROVIDED": "Not provided",
    "PROJECT_TYPE_DISPLAY": "Project Type:",
    "THUMBNAIL_LABEL": "Project Thumbnail:",
    "SELECT_THUMBNAIL": "Select Thumbnail",
    "SELECT_THUMBNAIL_HINT": "Select an image from your computer or enter a URL",
    "NO_THUMBNAIL": "No thumbnail selected",
    "RANDOM_TITLE": "Random Items",
    "RANDOM_DESC": "Each user will see the items in random order.",
    "HIGH_QUALITY_TITLE": "High Quality Thumbnail",
    "HIGH_QUALITY_DESC_PRO": "Use extra processing to improve the thumbnail.",
    "HIGH_QUALITY_DESC_NON_PRO": "Upgrade to Pro to enable high quality thumbnails.",
    "PRO_BADGE": "PRO",
    "BACK": "Back",
    "CREATE": "Create Project",
    "ERROR_TITLE": "Error",
    "ERROR_TITLE_LENGTH": "The title must be between 3 and 70 characters",
    "ERROR_DESC_LENGTH": "The description cannot exceed 200 characters",
    "ERROR_PRO_FEATURE": "High quality thumbnail is a Pro-exclusive feature.",
    "ERROR_NO_IMAGE": "You must provide a valid image for the thumbnail",
    "ERROR_CREATE": "An error occurred while creating the project. Please try again.",
    "ERROR_UPLOAD": "The project was created but there was an error uploading the thumbnail.",
    "ERROR_THUMBNAIL_URL": "The project was created but there was an error with the thumbnail.",
    "ERROR_IMAGE_LOAD": "Error loading image. Please select another image from the dialog."
  },
  "EDIT_FORM": {
    "PUBLIC": "Public",
    "PRIVATE": "Private",
    "CLICK_TO_ADD_THUMBNAIL": "Click to add a thumbnail",
    "UPDATING": "Updating...",
    "HD_THUMBNAIL": "HD Thumbnail",
    "PRO_BADGE": "PRO",
    "ITEMS_TITLE": "Items:",
    "SEARCH_PLACEHOLDER": "Search items (Enter)...",
    "BULK_UPLOAD_TITLE": "Bulk Import (PRO)",
    "TABLE_CONTENT": "Content",
    "TABLE_NAME": "Name",
    "TABLE_TYPE": "Type",
    "TABLE_ACTIONS": "Actions",
    "SELECT_ALL": "All",
    "INVALID_URL": "Invalid URL",
    "PAGINATION_PREV": "Back",
    "PAGINATION_NEXT": "Next",
    "ITEMS_SELECTED": "item(s) selected",
    "NO_SEARCH_RESULTS": "No items found matching",
    "NO_ITEMS": "There are no items in this project",
    "CLEAR_SELECTION": "Clear selection",
    "ITEM_NAME_LABEL": "Item Name:",
    "CONTENT_LABEL": "Content:",
    "TYPE_YOUTUBE": "🎬 YouTube",
    "TYPE_IMAGE": "🖼️ Image",
    "CHANGE_IMAGE": "Change Image/Video",
    "SELECT_IMAGE": "Select Image/Video",
    "INVALID_YOUTUBE_URL": "Invalid YouTube URL",
    "ENTER_VALID_URL": "Enter a valid URL",
    "SELECT_ITEM_TO_EDIT": "Select an item to edit",
    "UPDATE": "Update",
    "CANCEL": "Cancel",
    "INSERT_NEW_ITEM": "Insert New Item",
    "INSERT": "Insert",
    "UPGRADE_TITLE": "Upgrade Thumbnail",
    "UPGRADE_DESC": "Do you want to upload <strong>High Quality (HD)</strong> images for this project's thumbnail?",
    "UPGRADE_PRO_DESC": "This action will use PRO optimization technology when you upload a new image.",
    "UPGRADE_PROCESSING": "Processing...",
    "UPGRADE_NOW": "Upgrade now",
    "BULK_IMPORTING": "Importing Images...",
    "BULK_PROCESSING": "We are processing and optimizing your files. Please do not close this window.",
    "BULK_ERROR_TITLE": "Failed to upload these files",
    "BULK_ERROR_DESC": "The following files could not be uploaded:",
    "BULK_GOT_IT": "Got it",
    "BULK_ERROR_UNKNOWN": "Unknown error",
    "BULK_CHUNK_LABEL": "Batch #{{ chunk }}",
    "BULK_CHUNK_ERROR": "Error processing this batch of images.",
    "BULK_NETWORK_ERROR": "Could not connect to the server. Check your internet connection and try again.",
    "ERROR_TITLE": "Error",
    "ERROR_PRO_TITLE": "PRO Feature",
    "ERROR_VALIDATION_TITLE": "Validation",
    "ERROR_PRO_FEATURE": "This feature is exclusive to PRO users. Upgrade your account to enjoy it!",
    "ERROR_LOAD_PROJECT": "Could not load the project.",
    "ERROR_LOAD_DATA": "Could not load data. Check your connection.",
    "ERROR_ITEM_NAME_LENGTH": "Item name must be between 3 and 24 characters.",
    "ERROR_YOUTUBE_WORLD_CUP": "YouTube items are only allowed in World Cup projects.",
    "ERROR_UPDATE_ITEM": "Error updating item or uploading image.",
    "ERROR_CREATE_ITEM": "Error creating item or uploading image.",
    "ERROR_GIF_TIERLIST": "GIF images are not allowed for Tierlist projects.",
    "ERROR_MAX_50": "You can upload up to 50 images at a time.",
    "ERROR_BULK_PROCESS": "Error processing bulk upload.",
    "ERROR_UPGRADE_THUMBNAIL": "Could not upgrade thumbnail.",
    "SUCCESS_TITLE": "Success",
    "SUCCESS_IMPORT": "{{ count }} items imported successfully.",
    "INFO_TITLE": "Info",
    "INFO_NO_ITEMS": "No items were imported.",
    "BULK_DELETE_CONFIRM": "Delete all selected items? This action cannot be undone.",
    "BULK_DELETE_ITEMS_SELECTED": "items selected"
  },
  "EDIT_MODAL": {
    "TITLE": "Edit Project",
    "NAME_LABEL": "Project Name",
    "NAME_PLACEHOLDER": "Enter the project name",
    "DESC_LABEL": "Description",
    "DESC_PLACEHOLDER": "Enter the project description",
    "STATUS_LABEL": "Status",
    "STATUS_PUBLIC": "Public",
    "STATUS_PRIVATE": "Private",
    "RANDOM_ITEMS": "Random items",
    "DELETE_BUTTON": "Delete Project",
    "DELETING": "Deleting project...",
    "DELETE_DESC": "This action will permanently delete the project, all its items and images",
    "DELETE_TITLE": "Delete Project",
    "DELETE_CONFIRM": "Are you sure you want to delete this project? All items, images and associated data will be deleted. This action cannot be undone.",
    "CANCEL": "Cancel",
    "SAVE": "Save",
    "SAVING": "Saving...",
    "ERROR_NAME_LENGTH": "Project name must be between 3 and 50 characters.",
    "ERROR_DESC_LENGTH": "Description cannot exceed 200 characters."
  },
  "EMOJI_PICKER": {
    "TITLE": "Select Emoji",
    "TAB_OWN": "My Emojis",
    "TAB_FAVORITES": "Favorites",
    "LOADING_OWN": "Loading emojis...",
    "LOADING_FAVORITES": "Loading favorites...",
    "EMPTY_OWN": "You haven't created any emojis yet.",
    "EMPTY_OWN_HINT": "Go to My Creations to create emojis.",
    "EMPTY_FAVORITES": "You don't have any favorite emojis yet.",
    "EMPTY_FAVORITES_HINT": "You can add them from the comments."
  },
  "EMOJI_DETAILS": {
    "DELETE": "Delete Emoji",
    "REMOVE_FAVORITE": "Remove from Favorites",
    "ADD_FAVORITE": "Add to Favorites",
    "CANCEL": "Cancel",
    "ERROR_DELETE": "Error deleting emoji.",
    "ERROR_ADD_FAVORITE": "Could not add to favorites.",
    "ERROR_ADD_FAVORITE_ALT": "Error adding to favorites.",
    "ERROR_REMOVE_FAVORITE": "Error removing from favorites."
  },
  "FOOTER": {
    "TAGLINE": "Create, share and discover the best content.",
    "TERMS": "Terms",
    "PRIVACY": "Privacy",
    "CONTACT": "Contact",
    "COPYRIGHT": "All rights reserved.",
    "MADE_WITH": "Made with",
    "MADE_WITH_END": "passion."
  },
  "IMAGE_UPLOAD": {
    "TITLE_PROFILE": "Profile Picture",
    "TITLE_BANNER": "Banner",
    "TITLE_THUMBNAIL": "Project Thumbnail",
    "TITLE_ITEM_TIERLIST": "Item for Tierlist",
    "TITLE_ITEM": "Item",
    "TAB_URL": "Use URL",
    "TAB_UPLOAD": "Upload File",
    "URL_PLACEHOLDER": "https://example.com/image.jpg",
    "YOUTUBE_READY": "🎬 YouTube URL ready to use",
    "CLICK_SELECT": "Click to select file",
    "MAX_SIZE": "Max: {{ size }}MB",
    "REMOVE_IMAGE_TITLE": "Remove image",
    "CANCEL": "Cancel",
    "UPLOADING": "Uploading...",
    "UPLOAD_IMAGE": "Upload Image",
    "ERROR_GIF_TIERLIST": "GIF images are not allowed for Tierlist projects.",
    "ERROR_FILE_TOO_LARGE": "File is too large. Max {{ size }}MB",
    "ERROR_INVALID_URL": "Please enter a valid URL",
    "ERROR_UPLOAD_IMAGE": "Error uploading image: {{ msg }}",
    "ERROR_UPLOAD_THUMBNAIL": "Error uploading thumbnail: {{ msg }}",
    "ERROR_MISSING_ID": "Missing project ID",
    "ERROR_UPLOAD_ITEM": "Error uploading item image: {{ msg }}",
    "ERROR_SAVE_URL": "Error saving URL: {{ msg }}",
    "ERROR_YOUTUBE_WORLD_CUP": "YouTube items are only allowed in World Cup projects.",
    "ERROR_YOUTUBE_TIERLIST": "YouTube videos are not allowed for Tierlists. Images only.",
    "ERROR_UNSUPPORTED_TYPE": "This type does not support URL upload"
  },
  "ITEMS_TABLE": {
    "TITLE": "Item List",
    "PREV": "Back",
    "NEXT": "Next"
  },
  "RANKING_TABLE": {
    "TITLE": "Ranking",
    "NO_RESULTS": "No results",
    "CONTENT_ALT": "Content",
    "WIN_PERCENTAGE": "Win %",
    "ROUND_PERCENTAGE": "Round %",
    "PREV": "Back",
    "NEXT": "Next"
  },
  "TIERLIST": {
    "SEO_TITLE": "Tier list: {{ name }}",
    "NOT_AVAILABLE_DATE": "Date not available",
    "NEW_TIER": "New Tier",
    "DESCRIPTION_LABEL": "Description:",
    "NO_DESCRIPTION": "No description",
    "CREATED_BY": "Created by:",
    "PROFILE_ALT": "Profile picture",
    "LAST_UPDATE": "Last update:",
    "SAVE": "Save",
    "IMAGE_ALT": "Image",
    "SCROLL_HINT": "← scroll →",
    "ALL_ASSIGNED": "All items are assigned",
    "ROW_CONFIG_TITLE": "Row Configuration",
    "TAB_EDIT": "Edit row",
    "TAB_ACTIONS": "Actions",
    "ADD_ROW_ABOVE": "Add row above",
    "ADD_ROW_BELOW": "Add row below",
    "ROW_TEXT_LABEL": "Row Text",
    "BG_COLOR_LABEL": "Background Color",
    "CANCEL": "Cancel",
    "SAVE_ROW": "Save",
    "DELETE_ROW": "Delete row",
    "LIMIT_TITLE": "Limit",
    "MAX_ROWS_LIMIT": "A Tierlist project cannot have more than 10 rows.",
    "MIN_ROWS_LIMIT": "A Tierlist project must have at least 2 rows."
  },
  "WORLD_CUP": {
    "LOADING": "Loading...",
    "FINAL_ROUND": "Final Round",
    "ROUND_PROGRESS": "Round {{ current }}/{{ total }}",
    "SEO_TITLE": "Playing: {{ name }}",
    "PREPARING": "Preparing matchups...",
    "WINNER_TITLE": "🏆 Winner 🏆",
    "WINNER_ALT": "Winner image",
    "ACCEPT": "Accept",
    "ITEM_ALT": "Item image",
    "VS_ALT": "VS",
    "PHASE_PROGRESS": "Phase {{ display }} of {{ total }}"
  },
  "KMK": {
    "LOADING": "Setting up the game...",
    "TITLE": "Kiss · Marry · Kill",
    "BATCH_PROGRESS": "Batch {{ current }} of {{ total }}",
    "EMPTY_PLACEHOLDER": "— ° —",
    "ITEM_ALT": "Item",
    "NEXT": "Next →",
    "NO_ITEMS": "No items available for this project.",
    "RESULTS_TITLE": "Your results",
    "ROLE_KISS": "Kiss",
    "ROLE_MARRY": "Marry",
    "ROLE_KILL": "Kill",
    "LEGEND_KISS": "Kiss",
    "LEGEND_MARRY": "Marry",
    "LEGEND_KILL": "Kill",
    "PLAY_AGAIN": "🔄 Play again",
    "SEO_TITLE": "Kiss, Marry, Kill: {{ name }}"
  },
  "MY_CREATIONS": {
    "TITLE": "My Creations",
    "TAB_PROJECTS": "Projects",
    "TAB_EMOJIS": "Emojis",
    "SEARCH_PLACEHOLDER": "Search projects...",
    "SORT_CREATION_DATE": "Creation date",
    "SORT_LAST_UPDATE": "Last update",
    "SORT_MOST_RECENT": "Most recent",
    "SORT_OLDEST": "Oldest",
    "THUMBNAIL_ALT": "Thumbnail",
    "ITEMS": "items",
    "PUBLIC": "Public",
    "PRIVATE": "Private",
    "CREATE_PROJECT": "Create Project",
    "PAGINATION_PREV": "Back",
    "PAGINATION_NEXT": "Next",
    "PRO_BANNER_TITLE": "Custom emojis are a PRO feature",
    "PRO_BANNER_DESC": "Go PRO to create emojis and use them in comments.",
    "PRO_BANNER_BUTTON": "View PRO plan",
    "MY_EMOJIS": "My Emojis",
    "ADD_EMOJI_TITLE": "Create emoji",
    "ADD_EMOJI_LOCKED_TITLE": "Requires PRO plan",
    "EMPTY_EMOJIS_PRO": "You haven't created any emojis yet.",
    "EMPTY_EMOJIS_NON_PRO": "Go PRO to create your own emojis.",
    "FAVORITES_TITLE": "Favorites",
    "EMPTY_FAVORITES": "You don't have any favorite emojis yet. You can add them from the comments.",
    "CREATE_EMOJI_MODAL_TITLE": "Create Emoji",
    "PRO_BADGE": "PRO",
    "PRO_ONLY_TITLE": "PRO exclusive feature",
    "PRO_ONLY_DESC": "Go PRO to create custom emojis.",
    "CLOSE": "Close",
    "PREVIEW_ALT": "Preview",
    "PREVIEW_PLACEHOLDER": "Preview",
    "SHORTCODE_LABEL": "Emoji name (shortcode)",
    "SHORTCODE_PLACEHOLDER": "e.g. my_favorite_emoji",
    "SHORTCODE_VALID": "Valid shortcode. Usage: ",
    "SHORTCODE_HINT": "Only lowercase letters, numbers and _ (min. 3, max. 20 characters)",
    "CANCEL": "Cancel",
    "CREATING": "Creating...",
    "CREATE": "Create",
    "NOTIF_PRO_REQUIRED": "Creating emojis requires the PRO plan.",
    "ERROR_FILE_TYPE": "Invalid file type. Use JPG, PNG, GIF or WEBP.",
    "ERROR_MAX_SIZE": "Maximum 2MB.",
    "ERROR_GIF_SIZE": "Maximum 1.5MB for GIFs.",
    "ERROR_SHORTCODE_EMPTY": "Shortcode cannot be empty",
    "ERROR_SHORTCODE_MIN": "Minimum 3 characters",
    "ERROR_SHORTCODE_MAX": "Maximum 20 characters",
    "ERROR_SHORTCODE_PATTERN": "Only lowercase letters, numbers and _",
    "ERROR_CREATE_EMOJI": "Error creating reaction",
    "ERROR_PRO_FEATURE": "This feature requires the PRO plan.",
    "ERROR_CONNECTION": "Connection error. Try again."
  },
  "PRIVACY": {
    "BACK_HOME": "Back to home",
    "TITLE": "Privacy Policy",
    "SUBTITLE": "Your privacy is our priority",
    "SECTION_1_TITLE": "1. Data Collected",
    "SECTION_1_HTML": "We collect basic information such as your <b>email</b> and <b>username</b> to manage your account. We also store your mini-game configurations and chat messages so your experience remains persistent.",
    "SECTION_2_TITLE": "2. Use of Cookies",
    "SECTION_2_INTRO": "We use cookies and similar technologies for the following purposes:",
    "SECTION_2_LI_ESSENTIAL": "<b>Essential cookies:</b> Keep your session active and remember your visual preferences (such as dark mode).",
    "SECTION_2_LI_ADS": "<b>Advertising cookies:</b> We use <b>Google AdSense</b> and <b>DoubleClick</b> to show personalized ads based on your interests. These cookies collect information about your visit to generate relevant ads.",
    "SECTION_2_TRACKING_HTML": "We do not track your activity outside our platform. You can manage your advertising cookie preferences through <a href=\"https://adssettings.google.com\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-blue-600 dark:text-blue-400 underline\">Google Ads Settings</a>.",
    "SECTION_3_TITLE": "3. Third Parties and Google",
    "SECTION_3_INTRO": "We do not sell or rent your data to third parties. The third parties we work with are:",
    "SECTION_3_LI_GOOGLE": "<b>Google</b> — Login (OAuth 2.0) and advertising (AdSense). We only receive the public information (email, name, and avatar) that you authorize to create your profile.",
    "SECTION_3_LI_CLOUDINARY": "<b>Cloudinary</b> — Image storage and optimization.",
    "SECTION_3_DATA_USAGE_HTML": "<span class=\"font-medium text-blue-600 dark:text-blue-400\">Our use of information received from Google APIs will comply with the Google API Services User Data Policy, including the Limited Use requirements.</span>",
    "SECTION_4_TITLE": "4. Data Deletion",
    "SECTION_4_HTML": "You can request permanent deletion of your account and all associated data at any time from your settings panel. When you delete your account, all your personal data is immediately removed from our servers.",
    "SECTION_5_TITLE": "5. Advertising and Google AdSense",
    "SECTION_5_HTML_1": "We use <b>Google AdSense</b> to display ads on our platform. Google AdSense uses DoubleClick cookies to serve relevant ads and measure their performance. As part of Google's <b>EU User Consent Policy</b>, we ask for your consent before loading non-essential advertising cookies.",
    "SECTION_5_HTML_2": "You can learn more about Google's privacy practices at <a href=\"https://policies.google.com/privacy\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-blue-600 dark:text-blue-400 underline\">Google Privacy Policy</a> and manage your ad preferences at <a href=\"https://adssettings.google.com\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-blue-600 dark:text-blue-400 underline\">Google Ads Settings</a>.",
    "FOOTER_HTML": "If you have questions about how we handle your data, contact us at <a href=\"mailto:support@myplacetoday.com\" class=\"text-blue-600 dark:text-blue-400 underline\">support@myplacetoday.com</a>."
  },
  "PRO_SHOP": {
    "BACK": "Back",
    "SUBTITLE": "Take your experience to the next level with exclusive features and priority support.",
    "TAB_MY_SUBSCRIPTION": "My Subscription",
    "TAB_GIFT": "Gift PRO",
    "PLAN_LABEL": "{{ label }} Plan",
    "PLAN_TYPE_MONTHLY": "Monthly",
    "PLAN_TYPE_YEARLY": "Yearly",
    "STATUS_ACTIVE": "Active",
    "STATUS_PAUSED": "Paused",
    "STATUS_CANCELLED": "Cancelled",
    "STATUS_PENDING": "Pending",
    "STATUS_NO_SUBSCRIPTION": "No subscription",
    "STATUS_CANCELLED_ACCESS": "Guaranteed access until {{ date }}",
    "STATUS_NEXT_RENEWAL": "Next renewal: {{ date }}",
    "CHANGE_TITLE": "Want to switch?",
    "CHANGE_DESC": "You can upgrade to a yearly plan and save more.",
    "VIEW_OPTIONS": "View options",
    "CANCEL_TITLE": "Want to cancel?",
    "CANCEL_DESC": "You can cancel your subscription. You'll keep PRO until the end of the period.",
    "CANCEL_BUTTON": "Cancel",
    "CANCEL_OPTIONS_TITLE": "What do you prefer?",
    "SWITCH_TO_YEARLY": "Switch to yearly plan",
    "SWITCH_TO_YEARLY_DESC": "Save 20% and get 2 months free",
    "CANCEL_SUBSCRIPTION": "Cancel subscription",
    "CANCEL_SUBSCRIPTION_DESC": "You'll keep PRO until {{ date }}",
    "CONFIRM_CANCEL_TITLE": "Cancel subscription?",
    "CONFIRM_CANCEL_DESC": "You'll lose PRO access on {{ date }} and won't be charged further.",
    "GO_BACK": "Go back",
    "YES_CANCEL": "Yes, cancel",
    "PLANS_TITLE_PRO": "Upgrade your experience",
    "PLANS_TITLE_NON_PRO": "Choose your plan",
    "PLANS_DESC_PRO": "Switch your current plan to one with more benefits or longer duration.",
    "PLANS_DESC_NON_PRO": "Unlock premium features and customize your profile like never before.",
    "PLAN_CURRENT_BADGE": "Your Current Plan",
    "PLAN_RECOMMENDED_BADGE": "Recommended",
    "PLAN_SAVE_20": "SAVE 20%",
    "PLAN_BUTTON_CURRENT": "Current Plan",
    "PLAN_BUTTON_SWITCH": "Switch to this plan",
    "PLAN_BUTTON_CHOOSE": "Choose Plan",
    "PLAN_SWITCH_NOTE": "The change will apply at the end of your current period",
    "GIFT_TITLE": "Make a special gift",
    "GIFT_DESC": "Gift a month of PRO to any MyPlace user. The recipient will receive a notification and instant access.",
    "GIFT_CARD_TITLE": "PRO GIFT",
    "GIFT_CARD_SUBTITLE": "One month of premium features",
    "GIFT_USERNAME_LABEL": "Username",
    "GIFT_USERNAME_PLACEHOLDER": "Type the @username here",
    "GIFT_USERNAME_HINT": "Make sure to type the exact username.",
    "GIFT_INFO_TITLE": "What does this gift include?",
    "GIFT_INFO_1": "• One month of MyPlace PRO for the specified user.",
    "GIFT_INFO_2": "• Instant gift notification.",
    "GIFT_INFO_3": "• One-time payment (no recurring charges for you).",
    "GIFT_BUTTON": "Confirm and Pay ${{ price }}",
    "BADGE_SECURE_PAYMENT": "Secure Payment",
    "BADGE_AUTO_RENEWAL": "Auto-Renewal",
    "BADGE_CANCEL_ONLINE": "Cancel Online",
    "PLAN_MONTHLY_NAME": "Monthly PRO",
    "PLAN_MONTHLY_PERIOD": "month",
    "PLAN_MONTHLY_PERIOD_LABEL": "USD / month",
    "PLAN_MONTHLY_CTA": "Subscribe",
    "PLAN_MONTHLY_FEATURE_1": "Animated emojis (GIF)",
    "PLAN_MONTHLY_FEATURE_2": "High quality thumbnails",
    "PLAN_MONTHLY_FEATURE_3": "GIF upload in World Cup",
    "PLAN_MONTHLY_FEATURE_4": "Priority support",
    "PLAN_YEARLY_NAME": "Yearly PRO",
    "PLAN_YEARLY_PERIOD": "year",
    "PLAN_YEARLY_PERIOD_LABEL": "USD / year",
    "PLAN_YEARLY_CTA": "Subscribe",
    "PLAN_YEARLY_BADGE": "Most Popular!",
    "PLAN_YEARLY_FEATURE_1": "Everything in the monthly plan",
    "PLAN_YEARLY_FEATURE_2": "2 free months included",
    "PLAN_YEARLY_FEATURE_3": "Profile with exclusive PRO badge",
    "PLAN_YEARLY_FEATURE_4": "Early access to new features",
    "PLAN_GIFT_NAME": "Gift PRO",
    "PLAN_GIFT_PERIOD": "month",
    "PLAN_GIFT_PERIOD_LABEL": "USD / month — for a friend",
    "PLAN_GIFT_CTA": "Gift",
    "PLAN_GIFT_FEATURE_1": "One month of PRO for another user",
    "PLAN_GIFT_FEATURE_2": "The recipient receives a notification",
    "PLAN_GIFT_FEATURE_3": "Perfect as a special gift",
    "PLAN_GIFT_FEATURE_4": "One-time payment, no renewal",
    "NOTIF_PAYMENT_SUCCESS": "Payment successful! We're activating your PRO account...",
    "NOTIF_PAYMENT_FAILURE": "The payment could not be processed.",
    "NOTIF_PAYMENT_PENDING": "Payment pending. It will activate once credited.",
    "NOTIF_ACTIVE": "Done! Your PRO account is now active.",
    "NOTIF_VERIFY_TITLE": "Verify your email",
    "NOTIF_VERIFY_MSG": "You need to verify your email before continuing.",
    "NOTIF_GIFT_USERNAME_EMPTY": "Please enter the username of the person you want to gift the plan to.",
    "NOTIF_SELF_GIFT": "You cannot gift PRO to yourself. For your account, choose one of the subscription plans.",
    "NOTIF_PAYMENT_ERROR": "Error starting the payment.",
    "NOTIF_SUBSCRIPTION_ERROR": "Error creating the subscription.",
    "NOTIF_CANCEL_SUCCESS": "Subscription cancelled successfully.",
    "NOTIF_CANCEL_ERROR": "Error cancelling the subscription."
  },
  "RECOV_PASSWORD": {
    "TITLE": "Recover Password",
    "DESCRIPTION": "Enter your email and we'll send you a link to get back in.",
    "EMAIL_LABEL": "Account Email",
    "EMAIL_PLACEHOLDER": "ejemplo@email.com",
    "BUTTON": "Send Link",
    "BUTTON_LOADING": "Sending...",
    "BACK_TO_LOGIN": "← Back to login",
    "ERROR_EMAIL_EMPTY": "Please enter your email.",
    "SUCCESS_MESSAGE": "We've sent you an email with instructions.",
    "ERROR_GENERIC": "We couldn't process your request."
  },
  "REPORT_MODAL": {
    "TITLE": "REPORT",
    "SUBTITLE": "Help us keep MyPlace safe",
    "SUCCESS_TITLE": "Report sent!",
    "SUCCESS_DESC": "Thank you for your report. Our moderation team will review it as soon as possible.",
    "REPORTED_CONTENT_LABEL": "Reported content:",
    "REASON_LABEL": "Reason for report",
    "REASON_PLACEHOLDER": "Select a reason...",
    "DESCRIPTION_LABEL": "Additional details (optional)",
    "DESCRIPTION_PLACEHOLDER": "Give us more context about the issue...",
    "BUTTON": "Send Report",
    "BUTTON_LOADING": "Sending...",
    "REASON_SPAM": "Spam",
    "REASON_HARASSMENT": "Harassment or bullying",
    "REASON_INAPPROPRIATE": "Inappropriate content",
    "REASON_MISINFORMATION": "Misinformation",
    "REASON_COPYRIGHT": "Copyright violation",
    "REASON_HATE_SPEECH": "Hate speech",
    "REASON_OTHER": "Other",
    "ERROR_ALREADY_REPORTED": "You have already reported this content.",
    "ERROR_GENERIC": "There was an error sending your report. Please try again."
  },
  "SHARE_MODAL": {
    "TITLE": "SHARE",
    "SUBTITLE": "Invite your friends to play!",
    "COPY": "COPY",
    "COPIED": "COPIED",
    "COPY_SUCCESS_MSG": "Link ready to share",
    "SHARE_TEXT": "Check out this game on MyPlace! 🎮"
  },
  "RESET_PASSWORD": {
    "TITLE": "New Password",
    "DESCRIPTION": "Set your new access password.",
    "REDIRECTING": "Redirecting to login...",
    "BACK_TO_HOME": "Back to home",
    "EMAIL_LABEL": "Email",
    "NEW_PASSWORD_LABEL": "New Password",
    "CONFIRM_PASSWORD_LABEL": "Confirm Password",
    "SHOW_PASSWORD": "Show password",
    "HIDE_PASSWORD": "Hide password",
    "BUTTON": "Reset Password",
    "BUTTON_LOADING": "Saving...",
    "ERROR_INVALID_LINK": "The reset link is invalid or has expired.",
    "ERROR_PASSWORD_MISMATCH": "Passwords do not match.",
    "ERROR_PASSWORD_LENGTH": "Password must be at least 6 characters.",
    "SUCCESS_MESSAGE": "Password reset successfully.",
    "ERROR_GENERIC": "Error resetting password."
  },
  "SETUP_USERNAME": {
    "TITLE_FIRST_TIME": "Choose your username",
    "TITLE_CHANGE": "Change username",
    "DESC_FIRST_TIME": "This will be your public identity on the platform.<br>You can change it later by upgrading to <span class=\"text-emerald-400 font-semibold\">PRO</span>.",
    "DESC_CHANGE": "Changing your username is an exclusive feature for <span class=\"text-emerald-400 font-semibold\">Pro users</span>.",
    "USERNAME_LABEL": "Username:",
    "USERNAME_PLACEHOLDER": "your_user",
    "USERNAME_HINT": "3–20 characters · letters, numbers, and _ allowed",
    "ERROR_REQUIRED": "Username is required.",
    "ERROR_MIN_LENGTH": "Minimum 3 characters.",
    "ERROR_PATTERN": "Only letters, numbers, and underscores.",
    "ERROR_TAKEN": "This username is already taken.",
    "AVAILABLE": "Available!",
    "PRO_ONLY_TEXT": "Only Pro users can change their username.",
    "PRO_UPGRADE_LINK": "Upgrade to Pro",
    "BUTTON_CONTINUE": "Continue",
    "BUTTON_CHANGE": "Change Username (Pro)",
    "BUTTON_LOADING": "Saving...",
    "BACK_TO_SETTINGS": "Back to account settings",
    "ERROR_PRO_REQUIRED": "You need a Pro account to change your username.",
    "ERROR_INVALID_OR_TAKEN": "The username is invalid or already taken.",
    "ERROR_GENERIC": "Error saving. Please try again."
  },
  "SEARCH": {
    "FILTER_ALL": "All",
    "FILTER_PROJECTS": "Projects",
    "FILTER_USERS": "Users",
    "SORT_CREATION_DATE": "Creation date",
    "SORT_LAST_UPDATE": "Last update",
    "SORT_MOST_RECENT": "Most recent",
    "SORT_OLDEST": "Oldest",
    "RESULTS_HEADER": "Results for \"{{ query }}\"",
    "RESULTS_COUNT": "({{ count }} results)",
    "SEARCHING": "Searching...",
    "SECTION_PROJECTS": "Projects",
    "SECTION_USERS": "Users",
    "ITEMS_COUNT": "{{ count }} items",
    "NO_RESULTS_TITLE": "No results for \"{{ query }}\"",
    "NO_RESULTS_HINT": "Try with other filters or a different term.",
    "THUMBNAIL_ALT": "Thumbnail",
    "PROFILE_ALT": "Profile picture",
    "USER_CARD_VIEW_PROFILE": "View profile",
    "USER_SUBSCRIBERS_NONE": "No subscribers",
    "USER_SUBSCRIBERS_ONE": "1 subscriber",
    "USER_SUBSCRIBERS_MANY": "{{ count }} subscribers"
  },
  "TERMS": {
    "BACK_HOME": "Back to home",
    "TITLE": "Terms of Service",
    "LAST_UPDATED": "Last updated: April 2026",
    "SECTION_1_TITLE": "1. Minigames and Content",
    "SECTION_1_HTML": "Our platform allows users to create and share interactive minigames, including <b>World Cup (Tournaments)</b>, <b>Tierlists</b>, <b>Top Picks</b> and more. By uploading content, you guarantee that you own the necessary rights or that their use complies with local regulations.",
    "SECTION_2_TITLE": "2. Mature Content",
    "SECTION_2_INTRO": "We understand that art and entertainment can have different nuances. Mature-themed content is allowed as long as:",
    "SECTION_2_ITEM_1": "Appropriate warning tags are used.",
    "SECTION_2_ITEM_2": "It does not violate international laws (illegal content of any kind is not allowed).",
    "SECTION_2_ITEM_3": "It is not purely gratuitous or offensive toward minorities or groups.",
    "SECTION_3_TITLE": "3. Chat and Community",
    "SECTION_3_INTRO": "We provide a live chat system with <b>custom emojis</b>. By using it you agree to:",
    "SECTION_3_ITEM_1": "Not harass, intimidate, or disrespect other users.",
    "SECTION_3_ITEM_2": "Not spam messages or emojis.",
    "SECTION_3_ITEM_3": "Not share malicious links.",
    "SECTION_4_TITLE": "4. Responsibility",
    "SECTION_4_HTML": "<b>MyPlace</b> reserves the right to remove any content or suspend accounts that violate these terms without prior notice. You are solely responsible for the impact of your creations on the community.",
    "SECTION_5_TITLE": "5. Copyright (DMCA)",
    "SECTION_5_INTRO_HTML": "We respect intellectual property rights. If you believe your content has been copied in a way that constitutes copyright infringement, please notify <a href=\"mailto:support@myplacetoday.com\" class=\"text-blue-600 dark:text-blue-400 hover:underline\">support@myplacetoday.com</a> with the following information:",
    "SECTION_5_ITEM_1": "Identification of the copyrighted work.",
    "SECTION_5_ITEM_2": "Identification of the infringing content and its location on the platform.",
    "SECTION_5_ITEM_3": "Your contact information (name, email, phone).",
    "SECTION_5_ITEM_4": "A good faith statement that the use is not authorized.",
    "SECTION_5_ITEM_5": "A statement, under penalty of perjury, that the information is accurate.",
    "SECTION_5_ITEM_6": "Your physical or electronic signature.",
    "SECTION_5_OUTRO": "We will respond to all valid DMCA notifications and take appropriate action, including removal of infringing content.",
    "SECTION_6_TITLE": "6. Contact",
    "SECTION_6_TEXT": "For any questions about these terms, you can contact us at:"
  },
  "CONFIRM_DIALOG": {
    "TITLE_DELETE": "Confirm delete",
    "MESSAGE_DELETE": "Are you sure you want to delete this item?",
    "CONFIRM": "Delete",
    "CANCEL": "Cancel"
  },
  "VERIFY_EMAIL": {
    "TITLE_PENDING": "Verify your email",
    "DESC_PENDING": "We sent a verification link to your email.<br>Check your inbox and click the link.",
    "RESEND_BUTTON": "Resend email",
    "RESEND_BUTTON_LOADING": "Sending...",
    "RESEND_COOLDOWN": "Resend in {{ seconds }}s",
    "SPAM_HINT": "Also check your spam folder.",
    "TITLE_SUCCESS": "Email verified!",
    "TITLE_ALREADY_VERIFIED": "Already verified",
    "DESC_SUCCESS": "Your account is active. You can now use the platform.",
    "CONTINUE_BUTTON": "Continue",
    "TITLE_EXPIRED": "Link expired",
    "DESC_EXPIRED": "The verification link expired. Request a new one.",
    "REQUEST_NEW_LINK": "Request new link",
    "TITLE_INVALID": "Invalid link",
    "DESC_INVALID": "The link is invalid. Log in and request a new verification email.",
    "GO_HOME_BUTTON": "Go to home"
  },
  "VIEW_FORM": {
    "DESCRIPTION_LABEL": "Description:",
    "NO_DESCRIPTION": "No description",
    "CREATED_BY": "Created by:",
    "PROFILE_ALT": "Profile picture",
    "THUMBNAIL_ALT": "Thumbnail",
    "LAST_UPDATE_LABEL": "Last update:",
    "LIKE_ARIA": "Like",
    "UNLIKE_ARIA": "Unlike",
    "COOLDOWN_TOOLTIP": "You can unlike in {{ time }}",
    "REPORT_TITLE": "Report",
    "START": "Start",
    "START_WORLD_CUP": "Start World Cup",
    "HIDE_RANKINGS": "Hide rankings",
    "SHOW_RANKINGS": "Show rankings",
    "HIDE_ITEMS": "Hide items",
    "SHOW_ITEMS": "Show items",
    "HIDE_COMMENTS": "Hide comments",
    "SHOW_COMMENTS": "Show comments",
    "WORLD_CUP_SIZE_TITLE": "Select World Cup size",
    "WORLD_CUP_START": "Start",
    "WORLD_CUP_CANCEL": "Cancel",
    "ROUND_OPTION": "Round of {{ size }}",
    "NOTIF_LOGIN_TITLE": "Log in",
    "NOTIF_LOGIN_MSG": "You must log in to perform this action.",
    "NOTIF_VERIFY_TITLE": "Verify your email",
    "NOTIF_VERIFY_MSG": "You need to verify your email before continuing.",
    "ERROR_LOAD": "Error loading project",
    "DATE_UNAVAILABLE": "Date unavailable"
  }
}
